// Legacy import
import React, { useMemo } from "react"
//@ts-ignore
import { useNavigate } from "react-router-dom"
import styles from "./TopNavbar.module.scss"
import { Separator } from "@/ui/separator"
import { Button } from "@/ui/button"
import { MaterialIcon } from "@/ui/material-icon"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/ui/dropdown-menu"
import Breadcrumb from "@/shared/components/Breadcrumb/Breadcrumb"
import { toast } from 'sonner'
import { STORAGE_KEYS } from "@/shared/constants"
import { useUIConfig } from "@/features/auth/hooks/useUIConfig"

interface TopNavbarProps {
  breadcrumbs: string[]
}

const TopNavbar = ({ breadcrumbs }: TopNavbarProps) => {
  const navigate = useNavigate()
  const { data: uiConfig } = useUIConfig()

  const user = useMemo(() => {
    try {
      const json = localStorage.getItem(STORAGE_KEYS.USER)
      return json ? JSON.parse(json) : null
    } catch {
      return null
    }
  }, [])

  const handleLogout = () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.USER)
    navigate("/")
    toast.info('Logged out')
  }
  return (
    <header className={styles.navbar}>
      <div className={styles.navbar_wrapper}>
        <div className={styles.logo} onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          {uiConfig?.data?.logo ? (
            <img src={uiConfig.data.logo} alt="Platform logo" className={styles.logoImage} />
          ) : (
            <>
              <span className={styles.icon}>D</span>
              <span className={styles.brand}>{uiConfig?.data?.ui_config?.platform_name || 'DHIRA'}</span>
            </>
          )}
        </div>

        {/* Vertical divider */}
        <Separator orientation="vertical" className={styles.divider} />

        {/* Breadcrumb */}
        <div className={styles.breadcrumbArea}>
          <Breadcrumb items={breadcrumbs} />
        </div>

        {/* Right */}
        <div className={styles.right}>
          <Separator orientation="vertical" className={styles.divider} />
          <Button variant="ghost" size="icon" className={styles.bellBtn}>
            <MaterialIcon name="notifications" size={24} />
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className={styles.avatarButton}>
                <img
                  src={user?.avatar || "https://i.pravatar.cc/36"}
                  alt="profile"
                  className={styles.avatar}
                />
              </button>
            </DropdownMenuTrigger>

            <DropdownMenuContent side="bottom" align="end" className={styles.dropdownContent}>
              <div className={styles.dropdownHeader}>
                <div className={styles.dropdownName}>{user?.name || "Name Surname"}</div>
                <div className={styles.dropdownRole}>{user?.role || "Admin"}</div>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onSelect={handleLogout} className={styles.dropdownItem}>
                <MaterialIcon name="logout" size={16} className={styles.logoutIcon} />
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};

export default TopNavbar;